import * as React from "react";
import type { SVGProps } from "react";
const SvgMastercard = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={21}
    viewBox="0 0 32 21"
    {...props}
  >
    <rect
      width={31}
      height={20}
      x={0.5}
      y={1}
      fill="#fff"
      stroke="#F3F3F3"
      rx={3.5}
    />

    <path
      fill="#0D232D"
      fillRule="evenodd"
      d="M24.062 15.617h-.322v.833a.54.54 0 0 0-.46-.233c-.414 0-.736.35-.736.833s.322.833.736.833c.215 0 .368-.083.46-.233v.2h.322zm-9.503.633h.521v.317h-.52v.716c0 .167.06.267.214.267a.47.47 0 0 0 .276-.083l.092.3a.8.8 0 0 1-.399.116c-.368 0-.506-.216-.506-.583v-.733h-.29v-.317h.29v-.483h.322zm-4.245.6v1H9.96v-.883c0-.267-.107-.417-.322-.417-.199 0-.352.133-.352.417v.883h-.322v-.883c0-.267-.107-.417-.322-.417-.214 0-.352.133-.352.417v.883h-.322v-1.6h.322v.2a.48.48 0 0 1 .429-.233c.23 0 .383.1.49.283a.59.59 0 0 1 .521-.283c.368 0 .583.25.583.633m7.494-.633c-.183 0-.306.1-.383.233v-.2h-.322v1.6h.322v-.9c0-.267.107-.417.307-.417.061 0 .138.017.199.034l.092-.334c-.061-.016-.153-.016-.215-.016m-4.72 0c.23 0 .444.05.598.166l-.138.284a1.04 1.04 0 0 0-.46-.134c-.169 0-.276.067-.276.184 0 .1.107.133.245.15l.153.016c.307.05.506.2.506.484 0 .3-.245.516-.674.516-.23 0-.46-.066-.628-.2l.153-.266a.8.8 0 0 0 .49.166c.215 0 .337-.083.337-.2 0-.083-.092-.133-.26-.166l-.154-.017c-.321-.05-.505-.2-.505-.467 0-.316.245-.516.613-.516m9.15 0c-.184 0-.307.1-.383.233v-.2h-.322v1.6h.322v-.9c0-.267.107-.417.306-.417.061 0 .138.017.2.034l.091-.334c-.061-.016-.153-.016-.214-.016m-3.326 1.666c-.475 0-.782-.35-.782-.833s.307-.833.782-.833c.215 0 .368.05.521.183l-.153.283a.6.6 0 0 0-.383-.15c-.261.017-.445.217-.445.517 0 .317.184.517.445.517a.6.6 0 0 0 .383-.15l.153.283a.72.72 0 0 1-.521.183m2.192-1.633h-.322v.2a.54.54 0 0 0-.46-.233c-.414 0-.736.35-.736.833s.322.833.736.833c.215 0 .368-.083.46-.233v.2h.322zm-.736.283c-.276 0-.444.234-.444.517s.168.5.444.517c.26 0 .444-.234.444-.517 0-.3-.184-.517-.444-.517m-4.291-.316c-.43 0-.736.333-.736.833s.306.833.75.833a.9.9 0 0 0 .599-.216l-.154-.25a.7.7 0 0 1-.429.166c-.2 0-.398-.1-.444-.383h1.088v-.133c.015-.517-.26-.85-.675-.85m.367.683c-.03-.25-.168-.383-.367-.383-.23 0-.368.166-.399.383zm6.882-.367c-.276 0-.445.234-.445.517s.17.5.445.517c.26 0 .444-.234.444-.517 0-.3-.183-.517-.444-.517m-11.204-.283H11.8v.2a.54.54 0 0 0-.46-.233c-.413 0-.735.35-.735.833s.322.833.736.833c.214 0 .367-.083.46-.233v.2h.321zm-.75.283c-.277 0-.445.234-.445.517s.168.5.444.517c.26 0 .445-.234.445-.517 0-.3-.184-.517-.445-.517"
      clipRule="evenodd"
    />
    <path
      fill="#FF5F00"
      fillRule="evenodd"
      d="M16 4.855a5.73 5.73 0 0 1 2.114 4.458A5.68 5.68 0 0 1 16 13.771h-.015a5.7 5.7 0 0 1-2.115-4.458 5.73 5.73 0 0 1 2.115-4.458z"
      clipRule="evenodd"
    />
    <path
      fill="#EB001B"
      fillRule="evenodd"
      d="M13.87 9.313a5.73 5.73 0 0 1 2.114-4.458 5.45 5.45 0 0 0-3.427-1.213C9.485 3.642 7 6.178 7 9.313s2.485 5.671 5.557 5.671a5.45 5.45 0 0 0 3.427-1.213 5.7 5.7 0 0 1-2.115-4.458"
      clipRule="evenodd"
    />
    <path
      fill="#F79E1B"
      fillRule="evenodd"
      d="M24.984 9.313c0 3.135-2.485 5.671-5.557 5.671A5.45 5.45 0 0 1 16 13.771a5.68 5.68 0 0 0 2.115-4.458A5.73 5.73 0 0 0 16 4.855a5.45 5.45 0 0 1 3.427-1.213c3.072 0 5.557 2.552 5.557 5.671"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgMastercard;
